import type { DateValue } from 'components/filter/input/DateRangePicker/types';

export const BENCHMARKING_TEMPORAL_TYPE_WEEKLY = 'WEEKLY';
export const BENCHMARKING_TEMPORAL_TYPE_MONTHLY = 'MONTHLY';

export type BenchmarkingTemporalType = 'MONTHLY' | 'WEEKLY';

export interface BenchmarkingDateValue extends DateValue {
  temporalType: BenchmarkingTemporalType;
}
